import React, { useState, useEffect } from 'react';
import SatModal from '@components/common/satUI/SatModal';
import SearchLifePlanner from '@components/plan/SearchLifePlanner';

const JointSubscription = props => {
  const {
    lifePlannerList,
    searchPlannerList,
    onSearchPlanner,
    onSelectPlanner,
    onDeletePlanner,
    onInitPlanner,
    isLP,
    lpDeptYn,
  } = props;
  const [searchLifePlannerVisible, setSearchLifePlannerVisible] =
    useState(false);
  const [plannerLank, setPlannerLank] = useState(0);
  const [secondPlanner, setSecondPlanner] = useState('선택하기');
  const [thirdPlanner, setThirdPlanner] = useState('선택하기');

  useEffect(() => {
    if (searchLifePlannerVisible === false) onInitPlanner(); // 플래너 검색팝업 닫힐 때 검색내역 초기화
  }, [searchLifePlannerVisible]);

  useEffect(() => {
    const secondData = lifePlannerList.filter(
      planner => planner.jointApplicationRank === 2,
    );
    const thirdData = lifePlannerList.filter(
      planner => planner.jointApplicationRank === 3,
    );

    if (secondData.length > 0) {
      setSecondPlanner(
        `${secondData[0].agentEmpNm} (${secondData[0].agentagncNm})`,
      );
    } else {
      setSecondPlanner('선택하기');
    }

    if (thirdData.length > 0) {
      setThirdPlanner(
        `${thirdData[0].agentEmpNm} (${thirdData[0].agentagncNm})`,
      );
    } else {
      setThirdPlanner('선택하기');
    }
  }, [lifePlannerList]);

  const handleSelectedPlanner = planner => {
    onSelectPlanner({ selectedPlanner: planner, lank: plannerLank });
    setSearchLifePlannerVisible(false);
  };

  const showSearchCustomPopup = lank => {
    setPlannerLank(lank);
    setSearchLifePlannerVisible(true);
  };

  return (
    <React.Fragment>
      <div className="tit-area">
        <h2>{`공동청약 ${isLP && lpDeptYn
            ? '설계사'
            : 'LP'
        }`}</h2>
      </div>
      <div className="wrap-joint">
        <div className="box">
          <div className="txt">{`2순위 ${ isLP && lpDeptYn
            ? '설계사'
            : 'LP'
          }`}
          </div>
          <span
            className="inp-select-search"
            onClick={() => showSearchCustomPopup(2)}
          >
            {secondPlanner}
          </span>
          {lifePlannerList && lifePlannerList.length > 0 && (
            <span className="txt-delete" onClick={() => onDeletePlanner(2)}>
              삭제
            </span>
          )}
        </div>
        {lifePlannerList && lifePlannerList.length > 0 && (
          <div className="box">
            <div className="txt">{`3순위 ${ isLP && lpDeptYn
                ? '설계사'
                : 'LP'
              }`}
            </div>
            <span
              className={'inp-select-search'}
              onClick={() => showSearchCustomPopup(3)}
            >
              {thirdPlanner}
            </span>
            {lifePlannerList && lifePlannerList.length > 1 && (
              <span className="txt-delete" onClick={() => onDeletePlanner(3)}>
                삭제
              </span>
            )}
          </div>
        )}
      </div>
      <SatModal
        visible={searchLifePlannerVisible}
        setVisible={() => setSearchLifePlannerVisible(false)}
        wide
      >
        <SearchLifePlanner
          lank={plannerLank}
          plannerList={searchPlannerList}
          selectedLifePlannerList={lifePlannerList}
          onSearch={onSearchPlanner}
          onSelectPlanner={handleSelectedPlanner}
          isLP={isLP}
          lpDeptYn={lpDeptYn}
        />
      </SatModal>
    </React.Fragment>
  );
};

export default React.memo(JointSubscription);
